import { HelpTypes, MiscType, ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import strings from '../../../../localization';

const isSelfService = ServiceHandler.getService() === ServiceTypes.self;

export const incompatibleDropdown = () =>
  (isSelfService ? [
    { key: HelpTypes.pharmacist, label: strings.pharmacist },
    { key: HelpTypes.technicians, label: strings.technician },
    { key: HelpTypes.students, label: strings.pharmacyStudent },
    { key: MiscType.All, label: strings.all },
  ] : [
    { key: HelpTypes.pharmacist, label: strings.pharmacist },
    { key: HelpTypes.technicians, label: strings.technician },
    { key: MiscType.All, label: strings.all },
  ]);
